import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import avatarImg from "../../../assets/images/default-user.webp";


function EditFamilyDonor({data,setData,setShowForm,donor}) {

      const AuthToken = localStorage.getItem("AuthUser");

  const isEdit = !!donor;

  console.log("edit user in edit form",donor);
  console.log("Donor id",donor?.id);
const[formData,setFormData]= useState({
    name:"",
})

 useEffect(() => {
    if (donor) {
      setFormData({
        name: donor.name || "",
       
      });
    }
  }, [donor]);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/update-family-donor/${donor.id}`,
      formData
    );

    console.log("response after updating family donor", response.data);

    if (isEdit) {
      setData(prevData => ({
        ...prevData,
        donors: prevData.donors.map(d =>
          d.id === response.data.donor.id ? response.data.donor : d
        )
      }));
    } else {
      setData(prevData => ({
        ...prevData,
        donors: [...prevData.donors, response.data.donor]
      }));
    }

    setShowForm(false);
    setFormData({ name: "" });
  } catch (err) {
    console.error("Error updating family donor:", err);
  }
};


    return (
        <>
         <form onSubmit={handleSubmit} className="update-form container">
              <h3 className="mb-4 text-center">{isEdit ? "Edit Family Donor" : "Add Family Donor"}</h3>
        


                <div className="col-md-12 d-flex flex-row   gap-4 mx-auto">
                    
                  <div className="mb-3 w-50">
                    <label>Name</label>
                    <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} />
                  </div>
        
                
        
              <div className=" mt-4 w-50">
                <button type="submit" className={`btn ${isEdit ? "btn-success" : "btn-success"}` }>
                  {isEdit ? "Update User" : "Add User"}
                </button>
              </div>
</div>

            </form>
        </>
    )
}

export default EditFamilyDonor
